'use client';
import { gsap } from 'gsap';
import { useEffect, useRef } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import GrillFeatureComparisonItem from './_GrillFeatureComparisonItem';
import Section from '@repo/ui/src/components/Section';
import { ToutContent } from '@repo/ui/src/components/ToutContent';
import useProducts from '@hooks/product/useProducts';
import Product from '@models/product';

const SeriesGrillFeatureComparison = ({
  headingLine1,
  headingLine2,
  headerVariation,
  buttonText,
  buttonLabel,
  products: initialProducts,
  _data,
}) => {
  const smAndDown = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const { products } = useProducts(
    _data.map((x) => {
      const match = initialProducts.find((p) => p.product.id === x._meta?.deliveryId);
      return new Product({ ...match, ...x });
    }),
  );

  const ref = useRef(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    const timeline = new gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: '200px top',
        end: '40% top',
        scrub: 0.5,
        // markers: true,
      },
    });
    timeline.to(element.querySelector('.heading'), { opacity: 0 });
  }, []);

  return (
    <section ref={ref}>
      <Section
        dark
        texture
        gutterX
        className="tw-bg-surface-700 tw-relative before:tw-absolute before:tw-left-0 before:tw-right-0 before:tw-bottom-0 before:tw-h-[50vh] before:tw-bg-surface-100 before:tw-bg-speckle before:tw-bg-fixed portrait:tw-h-[80vw]"
      >
        <ToutContent
          dark
          flexible
          headingStyleVariant="h1"
          headingLight={headingLine1}
          heading={headingLine2}
          headerVariation={headerVariation}
          className="heading tw-sticky tw-top-0 tw-left-0 tw-right-0 tw-pt-16 tw-pb-8 tw-px-6 sm:tw-pt-36"
        />
        <Box
          display="flex"
          flexDirection={smAndDown ? 'column' : 'row'}
          alignItems="stretch"
          className="tw-py-6 lg:tw-py-[3vw]"
        >
          {products.map((product, i) => (
            <GrillFeatureComparisonItem
              key={product?.sku}
              product={product}
              buttonText={buttonText}
              buttonLabel={buttonLabel}
              index={i}
            />
          ))}
        </Box>
      </Section>
    </section>
  );
};

export default SeriesGrillFeatureComparison;
